<section class='form-builder-container'>
  <form class="form-builder-form" action="{{form_action_url}}" accept-charset="UTF-8" method="post">
    {{#if registerable_resource_type}}<input type="hidden" name="registration[resource_type]" value="{{registerable_resource_type}}" />{{/if}}
    {{#if registerable_resource_id}}<input type="hidden" name="registration[resource_id]" value="{{registerable_resource_id}}" />{{/if}}
    <input type="text" name="sparklehp" tabindex="-1" autocomplete="sparklehp" aria-label="Leave this field blank"/>
    <div>
      <div class="form-fields">
        {{#each groups}}
          {{#if fields}}
            <div class="field-input-group {{#if template_option}}field-input-group--{{template_option}}{{/if}}" data-group="field-input-group">
              {{#if label}}<div class="field-input-group__label" data-group="field-input-group-label">{{label}}</div>{{/if}}
              {{#each fields}}
                <dl class="field-input {{type}} field-input--size-{{#if size}}{{size}}{{else}}default{{/if}}">
                  {{!-- testIdPrefix derives data-testid="registration-<kebab field name>" per control at render time; standard field names align with the catalog's registration-* values --}}
                  {{> (fbPartial . "type") prefix="registration[fields]" index=@index testIdPrefix="registration"}}
                </dl>
              {{/each}}
            </div>
          {{/if}}
        {{/each}}
      </div>

      {{#if fields}}
      <input type="submit"
             name="commit"
             value="{{#if submit_text}}{{submit_text}}{{else}}Submit{{/if}}"
             class="submit"
             data-disable-with="Submitting..."/>
      {{/if}}
    </div>
  </form>
</section>
